import { Text, View } from "native-base"
import React, { RefObject, useRef, useState } from "react"
import { ColorValue, StyleSheet, View as V } from "react-native"
import ViewSmooth from "../../../Universal/View/ViewSmooth"
import { webFont } from "../../../Universal/API/API"
import { PressableWrap, PressableWrapProps } from "../../../Universal/Buttons/PressableColorWrap/PressableColorWrap"
import { scaleFont_ } from "../../../Universal/API/Scale"
import { handleExpandedMenu } from "../ExpandedMenu/utils"

export interface TopButtonProps {
    text: string,
    onPress?: (refExpandedMenu?: RefObject<handleExpandedMenu | null>) => void;
    minWidth?: number,
    onHoverIn?: PressableWrapProps['onHoverIn'],
    onHoverOut?: PressableWrapProps['onHoverOut'],
    addBottomLine?: boolean

}
const TopButton: React.FC<TopButtonProps> = ({ text, onHoverIn, onHoverOut, minWidth, onPress, addBottomLine= true }) => {
    const [color, setColor] = useState<ColorValue>('#1E1E1E')

    const refPress = useRef<V | null>(null)


    return (

        <View style={[styles.main, { minWidth: minWidth ?? 'auto', }]}>
            <PressableWrap
                ref={refPress}
                onHoverIn={onHoverIn}
                onHoverOut={onHoverOut}
                setColor={setColor}
                style={styles.pressableWrap}
                onPress={() => {
                    if (onPress) onPress()
                }}  >

                <Text style={[styles.text, { color: color }]}>
                    {text}
                </Text>



            </PressableWrap>
            

            

            
            {addBottomLine && <View style={[StyleSheet.absoluteFill, { flexDirection: 'column-reverse', }]} pointerEvents="none">
                <ViewSmooth style={[styles.bar, {
                    backgroundColor: color == '#1E1E1E' ? 'transparent' : color,
                }]} />
            </View>}

        </View>
    )
}

export default TopButton


const styles = StyleSheet.create({
    main: {
        height: '100%', position: 'relative',
    },
    pressableWrap: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
    text: { 
        fontSize: scaleFont_(16), 
        fontFamily: webFont('Inter'),
        fontWeight: '600', },
    barHolder: { 
        flexDirection: 'column-reverse',
    },
    bar: {
        bottom: 0,
        // backgroundColor: 'red',
        width: 100,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,

        height: 4,
        marginHorizontal: 'auto',
    }
})
